// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"cd33f169","359":"c11ceb01","595":"a945c7fd","767":"f16f1acd","963":"5edca4af"}[chunkId] + ".chunk.js";
};